import { selectPayoutDisability } from 'selectors/dashboard';
import { fetchDisability } from 'actions/digital-advice';
import { createPage } from './AwardRules';

export default createPage('disability', selectPayoutDisability, fetchDisability);
